/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

export const BaseVideoFragment = gql`
  fragment BaseVideoFragment on Video {
    __typename
    sys {
      id
    }
    options
    presets
    title
    videoAsset {
      url
      title
      description
      contentType
    }
    videoIdOrUrl
  }
`;
